import React, { useMemo } from 'react';
import { CalendarItem, CalendarInputCommonProps } from './types';
import { applyItemInterval, getNewCursorItem, getNextFocus, isCursorItemComplete, isItemValid } from './utils';
import { Button } from '../../button';
import { DisabledTooltip } from '../../tooltip';

export interface NowButtonProps extends CalendarInputCommonProps {
  fill?: boolean;
  children: React.ReactNode;
  shouldConfirm?: boolean;
  todayDisabledTooltip?: string;
}

export const NowButton: React.FC<NowButtonProps> = ({
  fill,
  children,
  constraint,
  resolution,
  items,
  cursor,
  target,
  shouldConfirm = true,
  disabled,
  onCursorChange,
  onConfirm,
  todayDisabledTooltip,
}) => {
  const item = useMemo(() => {
    const interval = resolution.resolve(new Date());
    let item: Partial<CalendarItem> | null = null;
    try {
      item = applyItemInterval(
        cursor?.item ?? getNewCursorItem(),
        constraint,
        { items },
        interval,
        target ?? cursor?.focus ?? 'from',
      ).item;
    } catch (e) {
      //
    }
    return item;
  }, [constraint, cursor?.focus, cursor?.item, items, resolution, target]);

  return (
    <DisabledTooltip
      disabled={(item == null || (disabled ?? false)) && !!todayDisabledTooltip}
      content={todayDisabledTooltip || ''}
      placement='top'
    >
      <Button
        fill={fill}
        variant='outlined'
        color='primary'
        disabled={item == null || disabled}
        onClick={() => {
          if (shouldConfirm) {
            if (isCursorItemComplete(item) && isItemValid(constraint, { items }, item)) {
              onConfirm(item);
            } else {
              onCursorChange({ ...cursor, item, focus: getNextFocus(cursor, target), toggled: true });
            }
          } else {
            onCursorChange({ ...cursor, item, focus: cursor?.focus });
          }
        }}
      >
        {children}
      </Button>
    </DisabledTooltip>
  );
};
